import { Link } from 'gatsby';
import { Icon } from '@upgrade/react-components';
import { mb, ml, mr, mt, my, p, pb, px, py } from '@upgrade/react-components/Spacing/core';
import styled from 'styled-components';

import { Hero } from '../common/styles';
import { StyledH5 } from '../common/typography';
import { SlideInUp } from '../../utils/animations';
import Image from '../common/Image';

export const StyledH2 = styled(StyledH5).attrs({ as: 'h2' })``;

export const StyledHero = styled(Hero)`
  ${pb('xl')}

  @media (max-width: ${props => props.theme.mediaSm}) {
    padding: 0;
  }
`;

export const StyledExperimentHero = styled(Hero)`
  ${pb('none')}
`;

export const Stats = styled.div`
  display: flex;
  padding: 0;
  padding: ${props => props.theme.spacing.lg} 0;
  text-align: left;

  .title--large {
    ${my('md')}
  }

  img {
    max-width: 10rem;
    height: auto;
    ${mr('md')}
  }

  @media (max-width: ${props => props.theme.mediaSm}) {
    border-bottom: ${({ noBorder, theme }) => (noBorder ? 'none' : `1px solid ${theme.palette.border}`)};
  }
`;

export const CenterImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const StyledImg = styled(Image)`
  display: none;
  max-width: 100%;
  height: auto;

  @media (min-width: ${props => props.theme.mediaSm}) {
    display: block;
    z-index: -1; // Display image behind hero text
  }
`;

export const StyledDownloadAppsImg = styled(Image)`
  height: auto;
  max-width: 100%;
`;

export const AppImage = styled(Image)`
  max-width: 10rem;
  height: 3rem;
  width: 100%;
`;

export const StyledQrCodeImage = styled(Image)`
  max-width: 100%;
  height: auto;
`;

export const CategoryItem = styled.div`
  background-color: ${({ theme }) => theme.palette.semanticInfoBackground || theme.palette.backgroundPrimary};
  flex: 1;
  ${p('md')}
  border-radius: 0.5rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  min-height: 16rem;
  ${mb('md')}
  height: 90%;

  @media (max-width: ${props => props.theme.mediaSm}) {
    flex-direction: ${({ isInlineOnMobile }) => (isInlineOnMobile ? 'row' : 'column')};
    align-items: ${({ isInlineOnMobile }) => (isInlineOnMobile ? 'center' : 'flex-start')};
    min-height: ${({ isInlineOnMobile }) => (isInlineOnMobile ? 'auto' : '16rem')};
  }

  span {
    text-transform: uppercase;
    font-weight: 400;
  }

  img {
    align-self: flex-end;
    @media (max-width: ${props => props.theme.mediaSm}) {
      max-width: 100%;
      height: auto;
    }
  }

  &:hover {
    background-color: ${props => props.theme.palette.backgroundStrong};
  }
`;

export const StyledLink = styled(Link)`
  display: block;
  text-decoration: none !important;
`;

export const StyledAppLink = styled(Link)`
  display: inline-block;
  text-decoration: none;
  ${mt('lg')}

  &:hover {
    text-decoration: none;
  }
`;

export const StyledIcon = styled(Icon)`
  ${ml('sm')}
`;

export const InnerContainer = styled.div`
  background-color: ${({ 'data-color': color = 'inherit', theme }) => theme.palette[color] || color};
  border-radius: ${({ theme }) => theme.containerBorderRadius};

  ${({ innerPadding = '5xl' }) => px(innerPadding)};
  ${({ verticalPadding = 'lg' }) => py(verticalPadding)}

  h2 {
    ${mb('sm')};
  }

  @media (max-width: ${props => props.theme.mediaSm}) {
    ${px('sm')}
    & > div {
      display: flex;
      flex-direction: column-reverse;
      border: none;
      align-items: center;

      img {
        max-width: 100%;
      }
    }
  }
`;

export const AppImageContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  ${mt('md')}

  @media (max-width: ${props => props.theme.mediaSm}) {
    justify-content: center;
  }
`;

export const AnimatedContainer = styled.div`
  overflow: hidden;

  .animated-slide-up {
    animation: ${SlideInUp} 0.5s ease-out;
  }
`;
